// extracted by mini-css-extract-plugin
export var aiButtonContainer = "_af-0";
export var orangeButton = "_af-1";